import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=4e5c0f51&scoped=true&"
import script from "./page-container.vue?vue&type=script&lang=js&"
export * from "./page-container.vue?vue&type=script&lang=js&"
import style0 from "./page-container.vue?vue&type=style&index=0&id=4e5c0f51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c0f51",
  null
  
)

export default component.exports